<div class="pt-3 pl-md-4 mb-6">

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-dismissible" role="alert"
         [class.alert-success]="modalResult.status === CallbackResultStatus.success"
         [class.alert-danger]="modalResult.status === CallbackResultStatus.error"
         *ngIf="modalResult">
      {{ modalResult.text }}
      <button type="button" class="close" (click)="modalResult = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-info" role="alert" *ngIf="loadingOrgConfig || loadingBannerImageOptions">
      Loading...
    </div>

    <div class="alert alert-info" role="alert" *ngIf="savingOrgConfig">
      Saving...
    </div>
  </div>

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin">
        Admin
      </a></li>
      <li class="breadcrumb-item"><a routerLink="/gifting-config">
        Gift Center
      </a></li>
      <li class="breadcrumb-item active" aria-current="page">
        Print Options
      </li>
    </ol>
  </nav>

  <h2>Gift Print Options</h2>

  <h2 *ngIf="serverError !== null">
    Server Error: {{ serverError }}
  </h2>

  <ng-container *ngIf="(serverError === null) && !loadingOrgConfig && !loadingBannerImageOptions">

    <div class="form-group">
      <label for="allow_printing_gifts">
        Do you want to allow customers to print PDFs of the gifts they purchase?
      </label>
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <select class="custom-select"
                  id="allow_printing_gifts"
                  name="allow_printing_gifts"
                  [(ngModel)]="orgConfig.allow_printing_gifts"
                  (ngModelChange)="saveOrganizationConfig()"
                  [disabled]="savingOrgConfig"
                  [class.disabled]="savingOrgConfig">
            <option [ngValue]="false">No</option>
            <option [ngValue]="true">Yes</option>
          </select>
        </div>
      </div>
      <small class="form-text text-muted">
        When enabled, customers purchasing a gift will have the option to download a PDF containing the gift information, which they can print to give to the gift recipient. This option will be presented as an alternative to email delivery of the gift.
      </small>
      <div class="text-danger">
        {{ errors.allow_printing_gifts }}
      </div>
    </div>

    <ng-container *ngIf="orgConfig.allow_printing_gifts">

      <div class="form-group">
        <label for="gift_print_paper_size">
          Gift PDF Paper Size
        </label>
        <div class="row">
          <div class="col-md-6 col-lg-4">
            <select class="custom-select"
                    id="gift_print_paper_size"
                    name="gift_print_paper_size"
                    [(ngModel)]="orgConfig.gift_print_paper_size"
                    (ngModelChange)="saveOrganizationConfig()"
                    [disabled]="savingOrgConfig"
                    [class.disabled]="savingOrgConfig">
              <option [ngValue]="PrintPageSize.letter">Letter</option>
              <option [ngValue]="PrintPageSize.a4">A4</option>
            </select>
          </div>
        </div>
        <div class="text-danger">
          {{ errors.gift_print_paper_size }}
        </div>
      </div>

      <div class="form-group">
        <label for="gift_print_logo_image">
          Gift PDF Logo Image
        </label>
        <input id="gift_print_logo_image"
               class="mb-2 d-block"
               type="file" accept=".png,.jpg,.jpeg"
               (change)="attachLogoImageFile($event)"
               [disabled]="savingOrgConfig"
               [class.disabled]="savingOrgConfig">
        <div class="d-block">
          <img *ngIf="orgConfig.gift_print_logo_image"
               [src]="orgConfig.gift_print_logo_image"
               width="80" height="80"
               class="d-inline"
               style="border: 1px solid black">
          <div *ngIf="!orgConfig.gift_print_logo_image"
               class="d-flex justify-content-center align-items-center"
               style="background-color: #d6d6d6; width: 80px; height: 80px;">
            <div>No image selected</div>
          </div>
          <button type="button" class="btn btn-sm btn-secondary d-inline ml-2 mt-2"
                  *ngIf="orgConfig.gift_print_logo_image !== null"
                  (click)="logoImageFileData = null; orgConfig.gift_print_logo_image = null; saveOrganizationConfig();">
            Remove Image
          </button>
        </div>
        <small class="form-text text-muted">
          This must be a square .png or .jpeg file no more than 2 MB in size. We recommend the image be 80 by 80 pixels.
          <br>
          If no image is provided, the logo configured in
          <a routerLink="/climber-app-customization">
            Climber App Customization Settings
          </a>
          will be used instead.
        </small>
        <div class="text-danger">
          {{ errors.gift_print_logo_image }}
        </div>
      </div>

      <div class="form-group">
        <label class="mb-0">Gift PDF Banner Image Options</label>

        <div class="indented-subsection pb-1">

          <div class="mt-2" *ngFor="let opt of bannerImageOptions">
            <span class="d-block">{{ opt.name }}</span>
            <img *ngIf="opt.image"
                 [src]="opt.image"
                 width="200" height="100"
                 class="d-inline"
                 style="border: 1px solid black">
            <div *ngIf="!opt.image"
                 class="d-flex justify-content-center align-items-center"
                 style="background-color: #d6d6d6; width: 200px; height: 100px;">
              <div>No image selected</div>
            </div>
            <button type="button"
                    class="btn btn-sm btn-outline-primary ml-2"
                    (click)="handleEditBannerImageOption(opt)">
              Edit
            </button>
            <button type="button"
                    class="btn btn-sm btn-outline-primary ml-2"
                    (click)="openPreviewModal(opt)">
              Preview
            </button>
            <button type="button"
                    class="btn btn-sm btn-outline-danger ml-2"
                    (click)="handleRemoveBannerImageOption(opt)">
              Remove
            </button>
          </div>

          <div class="mt-2" *ngIf="bannerImageOptions.length === 0">
            <span class="text-muted">
              No banner image options configured.
            </span>
          </div>

          <button type="button"
                  class="btn btn-sm btn-outline-success mt-3"
                  (click)="handleAddBannerImageOption()">
            Add Banner Image Option
          </button>

        </div>
      </div>

    </ng-container>

  </ng-container>

</div>
